export default "__VITE_ASSET__DZpoqtVV__"